<!--suppress CheckEmptyScriptTag -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <polygon points="25.922 29.485 6.078 29.485 6.078 2.515 18.883 2.515 25.922 9.554 25.922 29.485"
             class="cls-1 stroke"/>
    <polygon points="25.922 9.554 18.883 9.554 18.883 2.515 25.922 9.554"
             class="cls-1 stroke"/>
    <path
      d="M19.10564,14.95813a4.63583,4.63583,0,0,0-2.9225-1.17379c-1.7008,0-2.99436.86238-2.99436,2.22781s.86237,1.91639,2.92249,2.41944,3.09019.86238,3.09019,2.51527-1.67685,2.22781-3.04228,2.22781a5.42245,5.42245,0,0,1-3.52137-1.53312"
      class="cls-2 stroke"/>
    <line x1="16.19075" y1="12.5866" x2="16.19075" y2="24.92337" class="cls-2 stroke"/>
  </svg>
</template>

<script>
/**
 * SVG icon.
 */
export default {
  name: 'SvgProducts'
}
</script>

<style type="text/css">
.cls-1, .cls-2 {
  fill: none;
  stroke: #796e65;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.cls-2 {
  stroke-miterlimit: 10
}
</style>
